module.exports = __webpack_public_path__ + "img/5.05179a95.png";